import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthenticationService } from '@app/core/services/authentication.service';
import { AlertService } from '@app/core/services/alert.service';
import { FetchResult, ApolloError } from '@apollo/client/core';
import { AuthorizeUser } from '@app/core/results/user/authorize-user';
import { faLock, faUser } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {
  private componentDestroyed$: Subject<void> = new Subject();
  loginForm!: FormGroup;
  loadingLogin: boolean = false;
  submittedLogin: boolean = false;
  loadingForgotPassword: boolean = false;
  submittedForgotPassword: boolean = false;

  returnUrl!: string;

  faLock = faLock;
  faUser = faUser;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private alertService: AlertService) { }

  ngOnInit() {
    this.loginForm = new FormGroup({
      email: new FormControl('', Validators.required),
      password: new FormControl('', Validators.required)
    });

    // reset login status
    this.authenticationService.logOut();

    // get return url from route parameters or default to '/'
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'];
  }

  private onLoginResult(result: FetchResult<AuthorizeUser>) {
    if (result.errors) {
      this.alertService.error($localize `Sign-in failed.`, '');
    } else {
      this.alertService.success($localize `Sign-in.`, $localize `You has been sucessfully signed-in.`);
      if (this.returnUrl) {
        this.router.navigateByUrl(this.returnUrl);
      } else {
        this.router.navigate(['/dashboard']);
      }
    }
  }

  onSubmitLogin() {

    this.submittedLogin = true;

    // stop here if form is invalid
    if (this.loginForm.invalid) {
      return;
    }

    this.loadingLogin = true;
    this.authenticationService.login(this.loginForm.get('email')?.value, this.loginForm.get('password')?.value)
      .pipe(
        takeUntil(this.componentDestroyed$)
      )
      .subscribe((result: FetchResult<AuthorizeUser>) => {
        this.loadingLogin = false;
        this.onLoginResult(result);
      }, (error: ApolloError) => {
        this.loadingLogin = false;
        this.alertService.error($localize `Sign in failed.`, error.message);
      });
  }

  ngOnDestroy() {
    this.componentDestroyed$.next();
    this.componentDestroyed$.complete();
  }
}
